export default "assets/images/logo_dark-c10caa51.png";